import { serializeWalletFilters } from '@modules/consolidator/utils/serialize-wallet-filters/serialize-wallet-filters'

/**
 * Serializa os params da consolidação por GRUPO FAMILIAR.
 *
 * Irmão de `serialize-wallet-analysis-params`, não substituto: a guarda daquele
 * exige `id_cliente_app` e protege o caminho por cliente — afrouxá-la seria
 * regressão. Aqui a identificação obrigatória é o grupo.
 *
 * `id_grupo_familiar` vai no PATH da rota, nunca na query string — por isso é
 * destructurado fora dos filtros.
 *
 * @param {Object} args
 * @param {String} args.id_grupo_familiar UUID de `app_grupo_familiar.id`.
 * @returns {{ params: Object } | { error: String }}
 */
export const serializeGroupWalletParams = ({
  id_grupo_familiar,
  ...filters
} = {}) => {
  if (!id_grupo_familiar) {
    return { error: 'Não foi possível identificar o grupo familiar.' }
  }

  return { params: serializeWalletFilters(filters) }
}

/**
 * Identidade do recorte pedido ao backend — é o que distingue "mesmo grupo,
 * mesma pergunta" de "mesmo grupo, outra pergunta".
 *
 * Existe porque o store guarda UM payload (o da última carga): sem os filtros
 * na identidade, trocar o filtro de membro devolvia o consolidado inteiro do
 * cache e a tela não mudava nada.
 *
 * As chaves são ordenadas para que a ordem em que o usuário mexeu nos filtros
 * não invente um recorte novo.
 *
 * @param {Object} [params] Saída de `serializeGroupWalletParams`.
 * @returns {String} Chave estável.
 */
export const buildParamsKey = (params = {}) => {
  const fonte = params && typeof params === 'object' ? params : {}
  const partes = Object.keys(fonte)
    .sort((a, b) => a.localeCompare(b))
    .map((chave) => `${chave}=${JSON.stringify(fonte[chave])}`)
  return partes.join('&')
}
